// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledInput from '../../../claim/shared/components/claim-fields/labeled-input';
import LabeledKeyValueDropDown from '../../../claim/shared/components/claim-fields/labeled-key-value-dropdown';

const ClaimDebitFields = props =>
    <section className='claim-debit-fields'>
        <LabeledInput
            className='claim-number'
            isEditable={true}
            label='CLAIM_NUMBER'
            onChange={props.onClaimNumberChange}
            value={props.claimNumber}
        />
        <LabeledKeyValueDropDown
            className='debit-type'
            isEditable={true}
            label='DEBIT_TYPE'
            list={props.debitTypes}
            onChange={props.onDebitTypeChange}
            selectedValue={props.debitType}
        />
    </section>;

ClaimDebitFields.displayName = 'ClaimDebitFields';
ClaimDebitFields.propTypes = {
    claimNumber: PropTypes.string.isRequired,
    debitType: PropTypes.instanceOf(KeyValuePair).isRequired,
    debitTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onClaimNumberChange: PropTypes.func.isRequired,
    onDebitTypeChange: PropTypes.func.isRequired
};

export default ClaimDebitFields;



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/components/claim-debit-fields.js